import type {
  TDigestAction,
  TNotificationCategoryRow,
  TNotificationCell,
  TNotificationChannel,
  TOrgNotificationSettings,
} from './api';

const CHANNEL_LABEL: Partial<Record<TNotificationChannel, string>> = {
  in_app: 'In app',
  email: 'Email',
  slack: 'Slack',
  webhook: 'Webhook',
};

export const channelLabel = (channel: string): string =>
  CHANNEL_LABEL[channel as TNotificationChannel] ?? channel;

export const channelColumns = (categories: TNotificationCategoryRow[]): TNotificationChannel[] => {
  const seen: TNotificationChannel[] = [];
  for (const category of categories) {
    for (const cell of category.channels) {
      if (!seen.includes(cell.channel)) seen.push(cell.channel);
    }
  }
  return seen;
};

export const cellFor = (
  category: TNotificationCategoryRow,
  channel: TNotificationChannel,
): TNotificationCell | undefined =>
  category.channels.find((candidate) => candidate.channel === channel);

export const orgCellBlock = (cell: TNotificationCell | undefined): string | null => {
  if (!cell) return 'Not sent on this channel.';
  if (!cell.applicable) return 'Not sent on this channel.';
  if (!cell.availableToOrg) return 'This channel isn’t set up yet, so nothing can be sent on it.';
  return null;
};

export const unwiredChannels = (settings: TOrgNotificationSettings): string[] =>
  Object.entries(settings.channelsAvailable)
    .filter(([, available]) => !available)
    .map(([channel]) => channelLabel(channel));

export const digestTarget = (action: TDigestAction): string | null => {
  switch (action.kind) {
    case 'issue':
      return action.id ? `/issues/${action.id}` : null;
    case 'source':
      return action.id ? `/sources/${action.id}` : null;
    case 'storage':
      return '/settings/storage';
    case 'members':
      return '/settings/members';
    default:
      return null;
  }
};

export const ownWords = (count: number): string =>
  count === 1
    ? '1 change you made yourself is not listed.'
    : `${count.toLocaleString('en-US')} changes you made yourself are not listed.`;
